import React from 'react';
export default function DesignLayoutView(_ref) {
  var children = _ref.children;
  return React.createElement(React.Fragment, null, children || null);
}